import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent {
  brands = [
    { src: '/assets/images/partners_webp/abbott-logo.webp', alt: 'Abbott' },
    { src: '/assets/images/partners_webp/frisa.webp', alt: 'Frisa' },
    { src: '/assets/images/partners_webp/grupo-modelo-logo.webp', alt: 'Grupo Modelo' },
    { src: '/assets/images/partners_webp/la-salle-logo.webp', alt: 'La Salle' },
    { src: '/assets/images/partners_webp/Logo_CONADE_(2).svg.webp', alt: 'CONADE' },
    { src: '/assets/images/partners_webp/logo-stiva.webp', alt: 'Stiva' },
    { src: '/assets/images/partners_webp/LOreal-Logo.webp', alt: "L'Oréal" },
    { src: '/assets/images/partners_webp/MVS_Multivision-logo.webp', alt: 'MVS Multivisión' },
    { src: '/assets/images/partners_webp/Nestle.webp', alt: 'Nestlé' },
    { src: '/assets/images/partners_webp/Purina-Logo.webp', alt: 'Purina' },
    { src: '/assets/images/partners_webp/SEMAR_Logo.webp', alt: 'SEMAR' },
    { src: '/assets/images/partners_webp/The_Gillette_Company-Logo.webp', alt: 'Gillette' }
  ];

  get duplicatedBrands() {
    return [...this.brands, ...this.brands];
  }
}
